"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MinusCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-192.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(193.000000, 345.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(11.500000, 11.500000) rotate(-180.000000) translate(-11.500000, -11.500000) ",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 Z M11.5,2 C6.25329488,2 2,6.25329488 2,11.5 C2,16.7467051 6.25329488,21 11.5,21 C16.7467051,21 21,16.7467051 21,11.5 C21,6.25329488 16.7467051,2 11.5,2 Z M7.5,12.5 C6.94771525,12.5 6.5,12.0522847 6.5,11.5 C6.5,10.9871642 6.88604019,10.5644928 7.38337887,10.5067277 L7.5,10.5 L15.5,10.5 C16.0522847,10.5 16.5,10.9477153 16.5,11.5 C16.5,12.0128358 16.1139598,12.4355072 15.6166211,12.4932723 L15.5,12.5 L7.5,12.5 Z"
                })
              })
            })
          })
        })
      })
    })
  })]
});

MinusCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = MinusCircleIcon;
exports.default = _default;